import { render, staticRenderFns } from "./ChemLinks.vue?vue&type=template&id=c184b878"
import script from "./ChemLinks.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChemLinks.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports